// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__367Nd","left":"StickyBox_left__3Yv61","right":"StickyBox_right__tEhIn"};